var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appPage"},[_c('video',{staticClass:"videos-player",attrs:{"controls":"controls","id":"player","src":_vm.videoPaly.src,"poster":_vm.videoPaly.poster,"autoplay":""}},[_vm._v("您的浏览器不支持video , 该更新浏览器了")])])
}
var staticRenderFns = []

export { render, staticRenderFns }